import CiteModal from "components/CiteModal";
import { ICite } from "helpers/cite";
import { MixpanelCiteType } from "helpers/services/mixpanel/events";
import useLabels from "hooks/useLabels";

interface PropsType {
  data: ICite;
  open: boolean;
  onClose: () => void;
  downloadRIS?: () => void;
  eventTrackingDisabled?: boolean;
  citeEventOverride?: (citeType: MixpanelCiteType) => void;
}

export const PaperCiteModal = ({
  data,
  open,
  onClose,
  downloadRIS,
  citeEventOverride,
}: PropsType) => {
  const [labels] = useLabels("paper-cite-modal");
  return (
    <CiteModal
      title={labels["title"]}
      {...data}
      open={open}
      onClose={onClose}
      onDownloadRis={downloadRIS}
      citeEventOverride={citeEventOverride}
    />
  );
};
